import { render, staticRenderFns } from "./image-component.vue?vue&type=template&id=784b0e15&"
import script from "./image-component.vue?vue&type=script&lang=js&"
export * from "./image-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports